/** Match compensatory off / combo-off leave type names from master data */
export const isCompOffLeaveType = (leaveTypeName) => {
	if (!leaveTypeName || typeof leaveTypeName !== "string") return false;
	const normalized = leaveTypeName.toLowerCase().replace(/\s+/g, " ").trim();
	return (
		normalized.includes("compensatory") &&
		(normalized.includes("combo") ||
			normalized.includes("comp-off") ||
			normalized.includes("comp off"))
	);
};

export const findCompOffLeaveType = (leaveTypeMaster = []) =>
	leaveTypeMaster.find((t) => isCompOffLeaveType(t.LeaveTypeName));
